(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SmartChartsNXT", [], factory);
	else if(typeof exports === 'object')
		exports["SmartChartsNXT"] = factory();
	else
		root["SmartChartsNXT"] = factory();
})(this, () => {
return 